// The full-screen overlay hosts index.ts defines: the checkouts at z-index
// 9999, the timetable at 9998 (a checkout it opens stacks above it).
const CHECKOUT_OVERLAY_HOSTS = [
  "baluu-checkout-overlay",
  "baluu-giftcard-checkout-overlay",
  "baluu-basket-checkout-overlay",
  "baluu-pass-checkout-overlay",
  "baluu-membership-checkout-overlay",
  "baluu-product-checkout-overlay",
].join(",");
const OVERLAY_HOSTS = `${CHECKOUT_OVERLAY_HOSTS},baluu-timetable-overlay`;

const mounted = (selector: string) =>
  typeof document !== "undefined" && document.querySelector(selector) !== null;

/** Whether a checkout overlay is on the page — above the timetable overlay
 *  when both are, so the timetable leaves Escape alone (the checkouts have
 *  none: closing one throws away what was chosen in it). */
export function checkoutOverlayMounted(): boolean {
  return mounted(CHECKOUT_OVERLAY_HOSTS);
}

/** Whether any overlay host is on the page. Asked by the basket drawer as it
 *  opens (DRAWER_ABOVE_OVERLAYS_Z), so no caller has to know what's mounted
 *  to get the layer right. */
export function overlayHostMounted(): boolean {
  return mounted(OVERLAY_HOSTS);
}
